import { type Task } from "@repo/api";

import { type Appointment, type AppointmentStatus } from "../appointment/types";

const getDropInAppointmentStatus = (
  dropIn: Partial<Task>
): AppointmentStatus => {
  if (dropIn.taskActualStartTime) {
    return dropIn.taskActualEndTime ? "COMPLETED" : "STARTED";
  }
  if (dropIn.isDone) {
    return "COMPLETED";
  }
  return "ORDER_RECEIVED";
};

export const getDropInAppointment = (
  dropIn: Partial<Task>,
  countryCode: string
): Partial<Appointment> => {
  const appointment: Partial<Appointment> = {
    id: "",
    opportunityId: dropIn.opportunityId ?? undefined,
    opportunityTitle: "",
    assignedCoworker: dropIn.emailId ?? "",
    assignedTeam: dropIn.assignedTeam,
    appointmentStatus:
      dropIn.appointmentStatus ?? getDropInAppointmentStatus(dropIn),
    bookingTime: dropIn.created?.taskCreatedDateTime ?? "",

    locationName: dropIn.cmpCode ?? "",
    locationType: dropIn.cmpName?.includes("REMOTE") ? "REMOTE" : "STORE",
    orderNumber: "",
    price: 0,
    service: dropIn.service ?? "",
    timeWindowStartTime: dropIn.taskStartDateTime ?? "",
    timeWindowEndTime: dropIn.taskEndDateTime ?? "",
    actualTimeWindowStartTime: dropIn.taskActualStartTime,
    actualTimeWindowEndTime: dropIn.taskActualEndTime,
    type: "DROP_IN",
    serviceAreas: dropIn.hfb,
    countryCode,
  };

  if (dropIn.description) {
    appointment.comments = [
      { comment: dropIn.description, createdAt: new Date().getTime() },
    ];
  }

  return appointment;
};
